import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLandingContent } from "@/lib/landing/LandingContentProvider";
import { isLongLabel, phoneHref } from "@/lib/landing/resolve";
export default function LandingFinalCta({
  onBook,
  onCall,
}: {
  onBook: () => void;
  onCall: () => void;
}) {
  const { content } = useLandingContent();
  return (
    <section
      aria-labelledby="final-cta-title"
      className="bg-landing-red py-14 text-center text-primary-foreground sm:py-[84px]"
    >
      <div className="landing-container">
        <h2 id="final-cta-title" className="landing-cta-title">
          {content.finalCta.title}
        </h2>
        <p className="mt-3 text-[19px]">
          {content.finalCta.text}
        </p>
        <div className="mt-8 flex flex-col justify-center gap-4 sm:flex-row">
          <Button
            onClick={onBook}
            className={`h-[58px] rounded-xl bg-landing-light px-8 text-[17px] font-bold text-landing-ink hover:bg-landing-soft${isLongLabel(content.cta.label) ? " max-w-full whitespace-normal leading-[1.15]" : ""}`}
          >
            {content.cta.label} <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          <Button
            asChild
            variant="outline"
            className="h-[58px] rounded-xl border-2 border-landing-light bg-transparent px-8 text-[17px] font-bold text-primary-foreground hover:bg-landing-light hover:text-landing-ink"
          >
            <a href={phoneHref(content.phone)} onClick={onCall}>
              <Phone className="mr-2 h-5 w-5" />
              {`Call ${content.phone}`}
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
